import { HeadingDesc } from '../Headings';
import './qoutes.css';

function Qoutes(props) {
  const { heading, desc } = props;
  return (
    <div>
      {heading && (
        <div className="qoutes">
          <span className="boldText"> {heading || ''} </span>
          <HeadingDesc text={desc} />
        </div>
      )}
    </div>
  );
}

export default Qoutes;
